<template>
  <div class="search">
    <van-sticky>
      <van-nav-bar title="搜索" left-arrow @click-left="goback()" />

      <van-search
        v-model.trim="searchValue"
        show-action
        placeholder="请输入商铺/写字楼名称"
        @search="onSearchValue($event)"
        @clear="onCancel()"
        @cancel="onCancel()"
      />
    </van-sticky>

    <!-- 显示历史记录 -->
    <template v-if="searchHistoryShow">
      <div class="search_history">
        <div class="color999 fs13 flex_row jc_between ai_center">
          历史记录
          <van-icon
            class="m-r10"
            name="delete"
            size="15"
            color="#999"
            @click="removeHistoryInfo"
          />
        </div>
        <div class="history_list">
          <div
            class="list_item"
            v-for="item in historyInfo"
            :key="item"
            @click="onSearchList(item)"
          >
            <van-icon name="underway-o" size="15" color="#999" />
            <div class="color333 fs13 m-l10">{{ item }}</div>
          </div>
        </div>
      </div>
    </template>

    <!-- 显示搜索列表 -->
    <template v-else>
      <BuildingList :offsetTop="100" :searchValue="searchValue"></BuildingList>
    </template>

    <div></div>
  </div>
</template>
<script>
import storage from "@/utils/storage";
import { NavBar, Icon, Search, Sticky } from "vant";
import BuildingList from "./components/BuildingList";
export default {
  components: {
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Search.name]: Search,
    [Sticky.name]: Sticky,
    BuildingList,
  },
  data: function () {
    return {
      searchValue: "",
      searchHistoryShow: "",
      historyInfo: [],
    };
  },

  //初始化用户账号信息
  created() {
    this.searchHistoryShow =
      this.$route.query.searchShow === "1" ? true : false;
    var history = storage.getHistoryInfo();
    if (history) {
      this.historyInfo = history;
    }
  },

  methods: {
    //输入框获取焦点
    onSearchValue(value) {
      if (value.length > 0) {
        this.searchValue = value;
        this.searchHistoryShow = false;
        this.historyInfo.push(value);
        storage.setHistoryInfo(this.historyInfo);
      } else {
        this.searchHistoryShow = true;
      }
    },

    removeHistoryInfo() {
      storage.reMoveHistoryInfo();
      this.historyInfo = [];
    },

    onSearchList(value) {
      this.searchValue = value;
      this.searchHistoryShow = false;
    },

    //点击去掉输入框
    onCancel() {
      this.searchValue = "";
      this.searchHistoryShow = true;
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" >
.search {
  .search_history {
    display: flex;
    flex-direction: column;
    padding: 0px 10px;
    padding-top: 15px;

    .history_list {
      display: flex;
      flex-direction: column;

      .list_item {
        display: flex;
        align-items: center;
        padding: 15px 5px;
        border-bottom: 1px solid #f3f3f3;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/home/Search.vue